import React from 'react';

const NIcon = () => {
  return (
    <svg
      className="n-icon"
      // width="66"
      // height="144"
      // viewBox="0 0 66 144"
      width="86"
      height="164"
      viewBox="0 0 66 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2461_3347)">
        <path
          d="M42.6716 0V56.3213L23.4762 0H0V144H23.4762V87.2669L42.6716 144H66V0H42.6716Z"
          fill="#FFBF80"
        />
      </g>
      <defs>
        <clipPath id="clip0_2461_3347">
          <rect width="66" height="144" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NIcon;
